import ParkingOccupancyMonitoring from "../../components/ParkingOccupancyMonitoring";

const ParkingOccupancyMonitoringPage = () => {
  return <ParkingOccupancyMonitoring />;
};
export default ParkingOccupancyMonitoringPage;
